import React from 'react';
import { Construction } from 'lucide-react';
import { MetaTags } from '../components/seo/MetaTags';
import { SearchForm } from '../components/SearchForm';
import { FeaturedCategories } from '../components/FeaturedCategories';
import { PopularMerchants } from '../components/PopularMerchants';
import { generateHomeMeta } from '../lib/seo/generators';

export function HomePage() {
  const seo = generateHomeMeta();

  return (
    <div className="min-h-screen bg-gray-50">
      <MetaTags {...seo} />

      <div className="bg-gradient-to-r from-gray-900 to-gray-800 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <Construction className="w-16 h-16 text-yellow-400 mx-auto mb-6" />
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Find Quality Equipment Hire Near You
            </h1>
            <p className="text-xl text-gray-300">
              Discover trusted equipment hire providers for your construction, DIY, and garden projects
            </p>
          </div>
          <SearchForm />
        </div>
      </div>

      <FeaturedCategories />

      <div className="bg-gray-50">
        <PopularMerchants
          title="Popular Tool Hire in London"
          merchantType="Tool Hire"
          merchantSlug="tool-hire"
        />
        
        <div className="border-t border-gray-200">
          <PopularMerchants
            title="Skip Hire Services in Manchester"
            merchantType="Skip Hire"
            merchantSlug="skip-hire"
          />
        </div>
      </div>
    </div>
  );
}